var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.reportId == _vm.CREPORT.TYPE.FAILED_EMAILS)?_c('FailedEmails',{attrs:{"data":_vm.data}}):_vm._e(),(
            _vm.reportId == _vm.CREPORT.TYPE.REMINDERS_DETAIL ||
            _vm.reportId == 'reminder'
        )?_c('RemindersDetail',{ref:"remindersDetail",attrs:{"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }